import { apiConfig } from '@/configs/api.config'
import { BaseApi } from './base'

export const api = Object.assign(new BaseApi(apiConfig.baseURL), {
  /** API v2 instance — use for v2-only endpoints */
  v2: new BaseApi(apiConfig.v2BaseURL),
})
